import { render, staticRenderFns } from "./producto_listado.vue?vue&type=template&id=6b771e0e&scoped=true"
import script from "./producto_listado.vue?vue&type=script&lang=js"
export * from "./producto_listado.vue?vue&type=script&lang=js"
import style0 from "./producto_listado.vue?vue&type=style&index=0&id=6b771e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b771e0e",
  null
  
)

export default component.exports